import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const VendorForm = (
    {
        setVendorDetailsParent,
        setSection,
        formTextboxContainer,
        formTextboxLabel,
        formTextbox,
        formTextarea,
        orangeButton
    }
) => {
    // State for vendor details
    const [vendorDetails, setVendorDetails] = useState({
        vendorName: '',
        description: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        website: '',
        yearFounded: '',
        numberOfEmployees: '',
        revenue: '',
        isInnovationChallengeParticipant: false,
    });

    const [usStates] = useState([
        { value: "AL", label: "Alabama" },
        { value: "AK", label: "Alaska" },
        { value: "AZ", label: "Arizona" },
        { value: "AR", label: "Arkansas" },
        { value: "CA", label: "California" },
        { value: "CO", label: "Colorado" },
        { value: "CT", label: "Connecticut" },
        { value: "DE", label: "Delaware" },
        { value: "DC", label: "District Of Columbia" },
        { value: "FL", label: "Florida" },
        { value: "GA", label: "Georgia" },
        { value: "HI", label: "Hawaii" },
        { value: "ID", label: "Idaho" },
        { value: "IL", label: "Illinois" },
        { value: "IN", label: "Indiana" },
        { value: "IA", label: "Iowa" },
        { value: "KS", label: "Kansas" },
        { value: "KY", label: "Kentucky" },
        { value: "LA", label: "Louisiana" },
        { value: "ME", label: "Maine" },
        { value: "MD", label: "Maryland" },
        { value: "MA", label: "Massachusetts" },
        { value: "MI", label: "Michigan" },
        { value: "MN", label: "Minnesota" },
        { value: "MS", label: "Mississippi" },
        { value: "MO", label: "Missouri" },
        { value: "MT", label: "Montana" },
        { value: "NE", label: "Nebraska" },
        { value: "NV", label: "Nevada" },
        { value: "NH", label: "New Hampshire" },
        { value: "NJ", label: "New Jersey" },
        { value: "NM", label: "New Mexico" },
        { value: "NY", label: "New York" },
        { value: "NC", label: "North Carolina" },
        { value: "ND", label: "North Dakota" },
        { value: "OH", label: "Ohio" },
        { value: "OK", label: "Oklahoma" },
        { value: "OR", label: "Oregon" },
        { value: "PA", label: "Pennsylvania" },
        { value: "RI", label: "Rhode Island" },
        { value: "SC", label: "South Carolina" },
        { value: "SD", label: "South Dakota" },
        { value: "TN", label: "Tennessee" },
        { value: "TX", label: "Texas" },
        { value: "UT", label: "Utah" },
        { value: "VT", label: "Vermont" },
        { value: "VA", label: "Virginia" },
        { value: "WA", label: "Washington" },
        { value: "WV", label: "West Virginia" },
        { value: "WI", label: "Wisconsin" },
        { value: "WY", label: "Wyoming" },
    ]);

    // State for form errors
    const [formErrors, setFormErrors] = useState({});

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setVendorDetails({
            ...vendorDetails,
            [name]: type === 'checkbox' ? checked : value,
        });
        validateField(name, type === 'checkbox' ? checked : value);
    };

    // Validate individual fields
    const validateField = (name, value) => {
        let errors = { ...formErrors };

        switch (name) {
            case 'vendorName':
                errors.vendorName = value.trim() === '' ? 'Vendor Name is required' : '';
                break;
            case 'description':
                errors.description = value.trim() === '' ? 'Description is required' : '';
                break;
            case 'address':
                errors.address = value.trim() === '' ? 'Address is required' : '';
                break;
            case 'city':
                errors.city = value.trim() === '' ? 'City is required' : '';
                break;
            case 'state':
                errors.state = value.trim() === '' ? 'State is required' : '';
                break;
            case 'zipCode':
                errors.zipCode = value.trim() === '' ? 'ZIP Code is required' : '';
                break;
            case 'website':
                errors.website = value.trim() === '' ? 'Website is required' : '';
                break;
            case 'yearFounded':
                errors.yearFounded = value.trim() === '' ? 'Year Founded is required' : '';
                break;
            case 'numberOfEmployees':
                errors.numberOfEmployees = value === '' ? 'Number of Employees is required' : '';
                break;
            case 'revenue':
                errors.revenue = value === '' ? 'Revenue is required' : '';
                break;
            default:
                break;
        }

        setFormErrors(errors);
    };

    const validateAllFields = () => {
        const errors = {};

        if (vendorDetails.vendorName.trim() === '') {
            errors.vendorName = 'Vendor Name is required';
        }
        if (vendorDetails.description.trim() === '') {
            errors.description = 'Description is required';
        } else if (
            vendorDetails.description.split(/\s+/).filter((word) => word.length > 0).length > 200
        ) {
            errors.description = 'Description must be 200 words or less';
        }
        if (vendorDetails.address.trim() === '') {
            errors.address = 'Address is required';
        }
        if (vendorDetails.city.trim() === '') {
            errors.city = 'City is required';
        }
        if (vendorDetails.state.trim() === '') {
            errors.state = 'State is required';
        }
        if (vendorDetails.zipCode.trim() === '') {
            errors.zipCode = 'ZIP Code is required';
        } else if (!/^\d{5}$/.test(vendorDetails.zipCode)) {
            errors.zipCode = 'ZIP Code must be 5 digits';
        }
        if (vendorDetails.website.trim() === '') {
            errors.website = 'Website is required';
        }
        if (vendorDetails.yearFounded.trim() === '') {
            errors.yearFounded = 'Year Founded is required';
        } else if (!/^\d{4}$/.test(vendorDetails.yearFounded)) {
            errors.yearFounded = 'Year Founded must be a valid 4-digit year';
        } else {
            const year = parseInt(vendorDetails.yearFounded, 10);
            const currentYear = new Date().getFullYear();
            if (year < 1980 || year > currentYear) {
                errors.yearFounded = `Year Founded must be between 1980 and ${currentYear}`;
            }
        }
        if (vendorDetails.numberOfEmployees.trim() === '') {
            errors.numberOfEmployees = 'Number of Employees is required';
        }
        if (vendorDetails.revenue.trim() === '') {
            errors.revenue = 'Revenue Range is required';
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0; // Return true if no errors
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateAllFields()) {
            setVendorDetailsParent(vendorDetails);
            setSection(1);
        }
    };


    // Render the form
    return (
        <div className="container px-4 p-4">
            <form noValidate>
                {/* Vendor Name */}
                <div className="form-group mb-4">
                    <label className={formTextboxLabel}>
                        Vendor Name <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <input
                        type="text"
                        name="vendorName"
                        value={vendorDetails.vendorName}
                        onChange={handleInputChange}
                        className={`form-control ${formErrors.vendorName ? 'is-invalid' : ''} no-rounded`}
                        placeholder="Name of your company"
                        required
                        style={{ borderRadius: '0' }}
                    />
                    <div className="invalid-feedback">{formErrors.vendorName}</div>
                </div>

                {/* Vendor Description */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        Vendor Description <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <textarea
                        name="description"
                        value={vendorDetails.description}
                        onChange={handleInputChange}
                        className={`h-32 form-control ${formErrors.description ? 'is-invalid' : ''}`}
                        placeholder="A brief description of your company"
                        required
                        maxLength={2000}
                        style={{ borderRadius: '0' }}
                    />
                    <small className={`font-proximanova ${vendorDetails.description.length >= 2000 ? 'text-danger' : 'text-muted'}`}>
                        {2000 - vendorDetails.description.length} characters remaining
                    </small>
                    <div className="invalid-feedback">{formErrors.description}</div>
                </div>

                {/* Address */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        Street Address <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <input
                        type="text"
                        name="address"
                        value={vendorDetails.address}
                        onChange={handleInputChange}
                        className={`form-control ${formErrors.address ? 'is-invalid' : ''}`}
                        placeholder="Address"
                        required
                        style={{ borderRadius: '0' }}
                    />
                    <div className="invalid-feedback">{formErrors.address}</div>
                </div>

                {/* City */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        City <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <input
                        type="text"
                        name="city"
                        value={vendorDetails.city}
                        onChange={handleInputChange}
                        className={`form-control ${formErrors.city ? 'is-invalid' : ''}`}
                        placeholder="City"
                        required
                        style={{ borderRadius: '0' }}
                    />
                    <div className="invalid-feedback">{formErrors.city}</div>
                </div>

                {/* State */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        State <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <select
                        name="state"
                        value={vendorDetails.state}
                        onChange={handleInputChange}
                        className={`form-control ${formErrors.state ? 'is-invalid' : ''}`}
                        required
                        style={{ borderRadius: '0' }}
                    >
                        <option value="" disabled>Select State</option>
                        {usStates.map((state) => (
                            <option key={state.value} value={state.value}>
                                {state.label}
                            </option>
                        ))}
                    </select>
                    <div className="invalid-feedback">{formErrors.state}</div>
                </div>


                {/* ZIP Code */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        ZIP Code <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <input
                        name="zipCode"
                        type="text"
                        maxLength="5"
                        value={vendorDetails.zipCode}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,5}$/.test(value)) { // Allow only up to 5 digits
                                handleInputChange(e);
                            }
                        }}
                        className={`form-control ${formErrors.zipCode ? 'is-invalid' : ''}`}
                        placeholder="ZIP Code"
                        required
                        style={{ borderRadius: '0' }}
                    />
                    <div className="invalid-feedback">{formErrors.zipCode}</div>
                </div>

                {/* Website */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        Website <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <input
                        type="text"
                        name="website"
                        value={vendorDetails.website}
                        onChange={handleInputChange}
                        className={`form-control ${formErrors.website ? 'is-invalid' : ''}`}
                        placeholder="www.example.com"
                        required
                        style={{ borderRadius: '0' }}
                    />
                    <div className="invalid-feedback">{formErrors.website}</div>
                </div>

                {/* Year Founded */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        Year Founded <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <input
                        type="text"
                        name="yearFounded"
                        value={vendorDetails.yearFounded}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,4}$/.test(value)) {
                                handleInputChange(e);
                            }
                        }}
                        className={`form-control ${formErrors.yearFounded ? 'is-invalid' : ''}`}
                        placeholder="Year Founded"
                        required
                        style={{ borderRadius: '0' }}
                    />
                    <div className="invalid-feedback">{formErrors.yearFounded}</div>
                </div>

                {/* Number of Employees */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        Number of Employees <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <select
                        name="numberOfEmployees"
                        value={vendorDetails.numberOfEmployees}
                        onChange={handleInputChange}
                        className={`form-control ${formErrors.numberOfEmployees ? 'is-invalid' : ''}`}
                        required
                        style={{ borderRadius: '0' }}
                    >
                        <option value="" disabled>
                            Select Number of Employees
                        </option>
                        <option value="0-50">0-50</option>
                        <option value="51-100">51-100</option>
                        <option value="100-500">100-500</option>
                        <option value="500+">500+</option>
                    </select>
                    <div className="invalid-feedback">{formErrors.numberOfEmployees}</div>
                </div>

                {/* Revenue Range */}
                <div className="form-group my-4">
                    <label className={formTextboxLabel}>
                        Revenue Range <span style={{ color: '#9a016a' }}>*</span>
                    </label>
                    <select
                        name="revenue"
                        value={vendorDetails.revenue}
                        onChange={handleInputChange}
                        className={`form-control ${formErrors.revenue ? 'is-invalid' : ''}`}
                        style={{ borderRadius: '0' }}
                    >
                        <option value="">Select Revenue Range</option>
                        <option value="0-149999">$0 - $149,999</option>
                        <option value="150000-299999">$150,000 - $299,999</option>
                        <option value="300000-449999">$300,000 - $449,999</option>
                        <option value="450000-599999">$450,000 - $599,999</option>
                        <option value="600000-749999">$600,000 - $749,999</option>
                        <option value="750000-899999">$750,000 - $899,999</option>
                        <option value="900000-1049999">$900,000 - $1,049,999</option>
                        <option value="1050000-1199999">$1,050,000 - $1,199,999</option>
                        <option value="1200000-1349999">$1,200,000 - $1,349,999</option>
                        <option value="1350000-1499999">$1,350,000 - $1,499,999</option>
                        <option value="1500000+">$1,500,000+</option>
                    </select>
                    <div className="invalid-feedback">{formErrors.revenue}</div>
                </div>

                {/* Innovation Challenge Participant */}
                <div className="form-group my-4 form-check">
                    <input
                        type="checkbox"
                        name="isInnovationChallengeParticipant"
                        checked={vendorDetails.isInnovationChallengeParticipant}
                        onChange={handleInputChange}
                        className="form-check-input"
                        style={{ borderRadius: '0' }}
                    />
                    <label className="form-check-label">
                        I am or previously was a CharmHealth Innovation Challenge participant
                    </label>
                </div>

                {/* Next Button
                <button type="button" className={orangeButton} onClick={handleSubmit}>
                    Next
                </button> */}
                <div className="w-full flex justify-end">
                    <button className="w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2"
                        type="button"
                        onClick={handleSubmit}>
                        Next
                    </button>
                </div>
            </form>
        </div>
    );
};

export default VendorForm;